// src/components/ServerSearchBar.tsx
import React, { useCallback, useState } from "react";

export type ServerSearchBarProps = {
  /** ค่า query ที่ commit แล้ว (ใช้ยิง API จริง) */
  value: string;

  /** เรียกตอน commit ค้นหา (จะส่งค่า trim แล้ว) */
  onSearch: (query: string | undefined) => void;

  /** เรียกตอนกดรีเฟรช (เช่น ดึง SAS ใหม่) */
  onRefresh: () => void;

  /** loading state (ไว้ disable ปุ่ม/กันยิงซ้ำ) */
  loading?: boolean;

  /** placeholder */
  placeholder?: string;

  /** label บนปุ่มค้นหา */
  searchLabel?: string;

  /** label บนปุ่มรีเฟรช */
  refreshLabel?: string;

  /** initial input (ถ้าไม่ส่ง จะใช้ value เป็นค่าเริ่มต้น) */
  initialInput?: string;
};

export default function ServerSearchBar(props: ServerSearchBarProps): JSX.Element {
  const {
    value,
    onSearch,
    onRefresh,
    loading = false,
    placeholder = "ค้นหาโค้ด/ชื่อ/หน่วย (กด Enter เพื่อค้นหา server)",
    searchLabel = "ค้นหา",
    refreshLabel = "รีเฟรช",
    initialInput,
  } = props;

  // ✅ เหมือนตัวอย่าง: qInput แยกจาก q (value)
  const [qInput, setQInput] = useState<string>(initialInput ?? value ?? "");

  // ✅ เหมือนตัวอย่าง: commit query แบบ trim แล้วค่อยส่งไป parent
  const commitSearch = useCallback((): void => {
    const qVal = qInput.trim();
    onSearch(qVal || undefined);
  }, [qInput, onSearch]);

  return (
    <div className="d-flex flex-column gap-2 mb-3">
      <div className="input-group">
        <input
          className="form-control"
          placeholder={placeholder}
          value={qInput}
          onChange={(e) => setQInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && commitSearch()}
          aria-label="ค้นหา"
          disabled={loading}
        />
        <button
          className="btn btn-primary"
          type="button"
          onClick={commitSearch}
          disabled={loading}
        >
          {searchLabel}
        </button>
      </div>
    </div>
  )}
